import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { useCurrentUser } from './useCurrentUser'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface DeleteEventRatingResponse {
  success: boolean
  message?: string
}

export const useDeleteEventRating = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()
  const { data: userData } = useCurrentUser()
  const userId = userData?.userId || ''

  return useMutation<DeleteEventRatingResponse, Error, string>({
    mutationFn: async (eventId) => {
      if (!eventId) {
        throw new Error('Event ID is required to delete rating')
      }

      const response = await fetchWithAuth(
        `${URL}/events/${eventId}/ratings/me`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )

      return response
    },
    onSuccess: (data, eventId) => {
      // Invalidate related queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['eventRatings', eventId] })
      queryClient.invalidateQueries({
        queryKey: ['userEventRating', eventId, userId],
      })
      queryClient.invalidateQueries({ queryKey: ['event', eventId] })
    },
  })
}
